<template>
  <div v-if="item_id" id="success_container">
    <div class="tile is-parent" style="max-width: 500px; margin: auto">
      <article class="tile is-child box" style="">
        <div class="content">
          <div id="check" />
          <h2 style="text-align: center; margin-top: 0px">Success!</h2>
          <p style="text-align: center">
            You've successfully verified your business bank account!
          </p>
          <p style="text-align: center">
            You can now close this page. Your representative will contact you if
            we need any additional information.
          </p>
        </div>
      </article>
    </div>
  </div>
  <div v-else>
    <div id="main_container">
      <div style="" id="image_title_container">
        <img
          src="https://cardiff.b-cdn.net/img/ops_title.svg"
          id="logo"
          height="180"
          width="352"
          style="display: block"
        />
        <img
          src="https://cardiff.b-cdn.net/img/bank_icon.png"
          class="bank_icon"
          height="248"
          width="248"
          style="display: block"
        />
        <div class="buttons button_container">
          <a
            class="
              button
              is-link
              padded-button
              next-button
              pure-button
              btn-success
            "
            @click="back"
            id="continue-journey-lead-bank-verification"
            >CONNECT WITH PLAID</a
          >
        </div>
        <h3 id="advantages_title">
          Advantages of connecting with Plaid<sup>TM</sup>
        </h3>
        <p class="advantages_item">
          Applicants who connect with Plaid can be approved and funded same day
        </p>
        <div class="advantage_separator"></div>
        <p class="advantages_item">
          Receive an offer up to 30% more<sup>1</sup> when connected with Plaid
        </p>
        <div class="advantage_separator"></div>
        <p class="advantages_item">
          Choose a daily, weekly, or monthly payment schedule when connected
          with Plaid<sup>2</sup>
        </p>
        <h3 id="lets_try">Now, let’s try this again:</h3>
        <div class="buttons button_container">
          <a
            class="
              button
              is-link
              padded-button
              next-button
              pure-button
              btn-success
            "
            @click="back"
            id="continue-journey-lead-bank-verification"
            >CONNECT WITH PLAID</a
          >
        </div>
        <!-- <img
          src="https://cardiff.b-cdn.net/img/iphone_14_plaid.png"
          class="iphone_plaid_mobile"
          height="691"
          width="330"
        /> -->

        <p class="notes">
          *Cardiff can fund same day for applications approved by 5:00 p.m.
          Eastern Time on bank business days.
        </p>
        <p class="notes">
          <sup>1</sup>By connecting with Plaid<sup>TM</sup>, Cardiff will be
          able to evaluate your business banking data in real-time, thereby
          increasing its offer up to 30%.
        </p>
        <p class="notes">
          <sup>2</sup>As a result of successfully connecting with
          Plaid<sup>TM</sup>, Cardiff may be willing to allow the user to choose
          payment remittance cadence.
        </p>
      </div>
      <div id="image_container_desktop">
        <img
          src="https://cardiff.b-cdn.net/img/iphone-statement.png"
          class="iphone_plaid_desktop"
          height="723"
          width="948"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import $ from "jquery";
export default {
  name: "VerifyOpportunityFinish",
  components: {},
  props: {
    result: Boolean,
    item_id: String,
  },
  data() {
    return {};
  },
  mounted: function () {
    console.log(this.item_id);
    if (!this.item_id) {
      return;
    }

    var animation = lottie.loadAnimation({
      container: document.getElementById("check"), // the dom element that will contain the animation
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: "../animations/check.json", // the path to the animation json
    });
    setTimeout(function () {
      animation.play();
    }, 500);

    for (var i = 0; i < 80; i++) {
      create(i);
    }

    function create(i) {
      var width = Math.random() * 20;
      var height = width * 0.4;
      var colour = "green";

      $('<div class="confetti-' + i + " " + colour + '"></div>')
        .css({
          width: width + "px",
          height: height + "px",
          top: -Math.random() * 20 + "%",
          left: Math.random() * 100 + "%",
          opacity: Math.random() + 0.5,
          transform: "rotate(" + Math.random() * 360 + "deg)",
        })
        .appendTo("#app");
      drop(i);
    }

    function drop(x) {
      $(".confetti-" + x).animate(
        {
          top: "100%",
          left: "+=" + Math.random() * 15 + "%",
        },
        Math.random() * 3000 + 2000,
        function () {
          $(".confetti-" + x).remove();
        }
      );
    }
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    back() {
      this.$emit("back", this.$data);
      console.log(this.$data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
[class|="confetti"] {
  position: absolute;
}

.green {
  background-color: #3cb968;
}

.level {
  margin-bottom: 10px !important;
}

#check {
  max-width: 20%;
  margin: auto;
  display: block;
}
</style>
<style scoped>
#success_container {
  margin-top: 64px !important;
  height: 70vh;
}
sup {
  font-size: 50%;
}
#advantages_title {
  font-size: 36px;
  font-weight: bold;
  font: normal normal bold 32px/30px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
}
.advantages_item {
  font: normal normal normal 20px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
  /* margin-left: 5%;
  margin-right: 5%; */
}
.advantage_separator {
  border-top: 1px solid #ccc;
  padding-bottom: 10px;
  padding-top: 5px;
}

.iphone_plaid_mobile {
  display: none;
}
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
#main_container {
  display: flex;
  /* mobile */
  background: url("https://cardiff.b-cdn.net/img/gradient-desktop.png");
  background-repeat: no-repeat;
  /* /* height: 390px; */
}
#image_title_container {
  /* mobile */

  background-size: contain;
  /* max-height: 650px; */
  margin-left: 5%;
  /* background: transparent linear-gradient(52deg, #ffffff 0%, #d4dbec 100%) 0% 0%
    no-repeat padding-box;
  opacity: 1; */
}
#image_container_desktop {
  margin-top: 17px;
}
#logo {
  padding-top: 64px;
  /* margin-bottom: 21px; */
  width: 681px;
  /* height: 397px; */
}
#iphone_plaid {
  margin-bottom: 32px;
}
/* .button_container {
  margin-left: 3%;
} */
.notes {
  text-align: left;
  font: normal normal normal 16px/19px Roboto;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;
  margin-right: 8%;
}
.pure-button {
  border-radius: 24px;
  /* border: 2px solid transparent; */
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 500; */
  font-weight: 900;
  opacity: 1;
  text-align: center;
  font: normal normal 900 16px/40px Roboto;
  letter-spacing: 0.8px;
  color: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 0.9px;
  /* mobile */
  height: 48px;
  width: 240px;
}
.btn-success {
  background: #28a745 0% 0% no-repeat padding-box;
  color: #ffffff !important;
}
/* #app-column {
  padding-top: 0 !important;
} */
#lets_try {
  font: normal normal bold 32px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  margin-bottom: 32px;
}
@media (max-width: 80em) {
}
@media (max-width: 47.999em) {
  #success_container {
    margin-top: 64px !important;
    height: auto;
  }
  .btn-success {
    margin: 0 auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: -38px;
    padding-top: 48px;
    padding-top: 80px;

    max-height: none;
    background: url("https://cardiff.b-cdn.net/img/gradient-mobile.png");
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }

  .notes {
    /* margin-left: 32px; */
    margin-left: 8%;
  }
  #main_container {
    display: block;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
  }
  #logo {
    width: 90%;
    width: 340px;
    height: 208px;
    padding-top: 0;
    display: unset !important;
  }
  /* #image_title_container {
    display: unset;
  } */
  .bank_icon {
    display: unset !important;
  }
  #advantages_title {
    font-size: 24px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantages_item {
    font-size: 16px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantage_separator {
    margin-left: 8%;
    margin-right: 8%;
  }
  .pure-button {
    margin: 0 auto;
  }
}
</style>
<style>
#app-column-lead {
  padding: 0 !important;
}
.container.is-fluid {
  margin-left: 0;
  margin-right: 0;
}
.fullheight-lead {
  height: auto !important;
}
@media (max-width: 47.999em) {
  #app-column-lead {
    min-height: 60vh !important;
  }
}
</style>